import { Component } from '@angular/core';
import { NgFor } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-careers-page',
  standalone: true,
  imports: [NgFor, RouterLink],
  template: `
  <main class="page">
    <div class="container">
      <header class="head">
        <h1 class="h1">Carrières</h1>
        <p class="lead">Rejoignez notre équipe d’experts data. Projets à fort impact, culture analytique, excellence technique.</p>
      </header>

      <div class="grid">
        <article class="card" *ngFor="let r of roles" [style.background-image]="bgFor(r.img)">
          <h2 class="h2">{{r.title}}</h2>
          <p class="muted">{{r.desc}}</p>
          <ul class="list">
            <li *ngFor="let x of r.skills">{{x}}</li>
          </ul>
          <a class="btn sm ghost" routerLink="/contact">Postuler</a>
        </article>
      </div>

      <div class="cta">
        <a class="btn primary" routerLink="/contact">Candidature spontanée</a>
      </div>
    </div>
  </main>
  `,
  styles: [`
    .page{ padding: 44px 0 70px; }
    .lead{ color: var(--muted); font-weight: 750; max-width: 980px; }

    .grid{
      margin-top: 16px;
      display:grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 14px;
    }
    .card{
      position: relative;
      border-radius: 26px;
      border: 1px solid rgba(255,255,255,.10);
      padding: 22px;

      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;

      overflow: hidden;
      box-shadow: 0 30px 120px rgba(0,0,0,.45);
    }

    /* dark overlay for readability */
    .card::before{
      content:"";
      position:absolute;
      inset:0;
      background: linear-gradient(
          to top,
          rgba(7,11,23,.95) 20%,
          rgba(7,11,23,.70) 50%,
          rgba(7,11,23,.30) 80%
      );
    }

    /* text above overlay */
    .card > *{
      position: relative;
      z-index: 2;
    }
    .muted{ color: var(--muted); font-weight: 750; }
    .list{ margin: 10px 0 14px; padding-left: 18px; color: var(--muted); font-weight: 750; }
    .list li{ margin: 7px 0; }
    .cta{ margin-top: 18px; }

    @media (max-width: 980px){
      .grid{ grid-template-columns: 1fr; }
    }
  `]
})
export class CareersPageComponent {
  roles = [
    { title: 'Data Analyst', desc: 'KPI, storytelling, Power BI / Qlik, SQL.', skills: ['KPI & Reporting', 'Storytelling', 'SQL', 'Power BI / Qlik'],img:'/assets/blog-icons/dbs-icon-analytics.png' },
    { title: 'Business Analyst Data', desc: 'Analyse métier, optimisation process.', skills: ['Analyse métier', 'Workshops', 'Optimisation process', 'KPIs'],img: '/assets/blog-icons/dbs-icon-bi.png'},
    { title: 'Data Scientist', desc: 'ML, forecasting, Python, explicabilité.', skills: ['Forecasting', 'Machine Learning', 'Python', 'Explainabilité'],img: '/assets/blog-icons/dbs-icon-science.png' },
    { title: 'Data Engineer', desc: 'Pipelines ELT/ETL, data warehouse, qualité, monitoring.', skills: ['ETL/ELT', 'DWH', 'Qualité data', 'Monitoring'] ,img: '/assets/blog-icons/dbs-icon-engineering.png'},
  ];
  bgFor(img: string): string {
    return `url('${img}')`;
  }
}
